// extracted by mini-css-extract-plugin
export default {"card":"Q2-z"};